<template>
  <div>
    <div>
      <p style="color: #9e9c9b; font-size: 13px; margin-top: -10px; margin-left: 2px">PUBLIC SALES ARE LIVE</p>
      <p style="font-size: 36px; margin-top: 5px">MOAR <span style="color: #cd4743">Tron</span></p>
    </div>

    <div v-if="!isSoldOut" class="center" style="justify-content: flex-start; margin: 10px 0">
      <img src="@/assets/pc/trx.png" style="width: 30px; margin-right: 10px" />
      <p style="white-space: nowrap">
        <span style="font-size: 20px">100 TRX </span
        ><span style="font-size: 14px; font-style: italic; color: #9e9c9b">per unit</span>
      </p>
    </div>

    <div class="mint-box" v-if="!isSoldOut">
      <!-- total available -->
      <div style="height: 80px; padding-top: 10px">
        <p style="font-size: 17px">
          Total Available:
          <span v-if="!isConnected">Connect your wallet to see</span>
          <!-- <span v-else-if="hasQuriedNum">{{max}}</span> -->
          <span v-else>{{ max }}</span>
        </p>
        <p style="font-size: 12px; font-style: italic; margin-top: 5px; margin-bottom: 20px">
          Price per unit: 100TRX + Gas Fee
        </p>
      </div>
      <!-- num-select -->
      <div class="mint-select center">
        <div class="edit-icon center" :class="{ disabled: minusDisabled }" @click="minusMintNum">&#8722;</div>
        <input
          class="edit-input"
          v-model.number="mintNum"
          @keypress="onlyNumber($event)"
          @blur="onBlur"
          :disabled="true"
        />
        <div class="edit-icon center" :class="{ disabled: addDisabled }" @click="addMintNum">&#43;</div>
      </div>
      <!-- confirm -->
      <div>
        <div class="mint-confirm center" v-if="!isConnected && !isConnecting" @click="connectWallet">
          CONNECT WALLET
        </div>
        <div class="mint-confirm center disabled" v-else-if="isConnecting">CONNECTING..</div>
        <div class="mint-confirm center" :class="{ disabled: !canMint }" v-else-if="!isMinting" @click="triggerMint">
          MINT
        </div>
        <div class="mint-confirm center disabled" v-else>MINTING..</div>
      </div>
    </div>

    <a class="mint-box-soldout" v-else href="https://apenft.io/collections/asunatron">
      <p style="font-size: 40px; font-weight: bold">SOLD OUT</p>
      <p style="font-size: 14px; font-weight: bold; margin-top: 5px">BUY ON APENET</p>
      <img src="@/assets/pc/sold-out-icon.png" id="soldout-icon" />
    </a>
  </div>
</template>
<script>
import { walletMixin } from '../mixin.js';
export default {
  name: 'stage23',
  mixins: [walletMixin],
  props: {
    countdownArr: [],
    stage: Number,
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.countdown-box {
  width: 39px;
  height: 29px;
  background: #cd4743;
  border-radius: 3px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.countdown-divider {
  color: #cd4743;
  margin: 0 5px;
}
.mint-box {
  background-color: #fff;
  border-radius: 5px;
  text-align: center;
  color: #000;
  width: 230px;
  padding: 16px 16px;
  margin-top: 20px;
}
.mint-box-soldout {
  background-color: #fff;
  border-radius: 5px;
  text-align: center;
  color: #000;
  width: 260px;
  margin-top: 20px;
  display: block;
  padding: 40px 0 60px 0;
  position: relative;
  #soldout-icon {
    width: 60px;
    position: absolute;
    bottom: 10px;
    left: 100px;
  }
}
.mint-select {
  width: 100px;
  margin: 12px auto;
  .edit-icon {
    width: 18px;
    height: 18px;
    background-color: #cd4743;
    font-size: 18px;
    border-radius: 100%;
    color: #fff;
    cursor: pointer;
    padding-bottom: 3px;
    font-weight: normal;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  .edit-input {
    font-size: 20px;
    font-family: 'Helvetica', 'Arial', sans-serif;
    font-weight: bold;
    color: #000;
    width: 42px;
    text-align: center;
  }
}
.mint-confirm {
  width: 193px;
  height: 32px;
  border-radius: 5px;
  background-color: #cd4743;
  color: #fff;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 2px;
  font-size: 12px;
  &.disabled {
    opacity: 0.5;
  }
}
</style>
